/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Exporting_TitleInputs */

const en_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Exporting`)
};

const fr_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lots`)
};

const de_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelexport`)
};

const it_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione in batch`)
};

const ru_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт`)
};

const es_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación por lotes`)
};

const zh_cn2_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出`)
};

const ja_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチエクスポート`)
};

const hi_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच निर्यात`)
};

const pt_pt2_explorer_info_batch_exporting_title = /** @type {(inputs: Explorer_Info_Batch_Exporting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote`)
};

/**
* | output |
* | --- |
* | "Batch Exporting" |
*
* @param {Explorer_Info_Batch_Exporting_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_exporting_title = /** @type {((inputs?: Explorer_Info_Batch_Exporting_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Exporting_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_exporting_title(inputs)
	if (locale === "de") return de_explorer_info_batch_exporting_title(inputs)
	if (locale === "it") return it_explorer_info_batch_exporting_title(inputs)
	if (locale === "ru") return ru_explorer_info_batch_exporting_title(inputs)
	if (locale === "es") return es_explorer_info_batch_exporting_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_exporting_title(inputs)
	if (locale === "ja") return ja_explorer_info_batch_exporting_title(inputs)
	if (locale === "hi") return hi_explorer_info_batch_exporting_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_exporting_title(inputs)
	return en_explorer_info_batch_exporting_title(inputs)
});